export default __webpack_public_path__ + "static/media/g-v-nageswara.d4043e11.png";